import DesignTokens from '@tableau/design-tokens';
import { Tooltip, TooltipPosition } from '@tableau/widgets';
import React from 'react';

import { applyColor }from '~src/style/ColorService';

import { CommonStyles } from '../../styles/CommonStyles';

const cellStyle: React.CSSProperties = { cursor: 'default', ...CommonStyles.Layout.FlexBlockLeftAndCenter };

const countStyle: React.CSSProperties = {
  color: applyColor(DesignTokens.color.font.default.subtle, CommonStyles.Colors.Grey153),
  flex: 'none',
  marginLeft: CommonStyles.Sizes.DefaultSpace
};

export const CountPill: React.FC<{ count: string, onClick?: React.MouseEventHandler }> = ({ count, ...restProps }) =>
  <span
    data-tb-test-id="data-grid-cell-count"
    style={{ ...countStyle, ...(restProps.onClick && { cursor: 'pointer' }) }}
    {...restProps}
  >
    {count}
  </span>;

export type CellWithCountProps = { count?: string, testId?: string };
export const CellWithCountPill: React.FC<CellWithCountProps & { onCountClick?: () => void }> = props => {
  return (
    <span data-tb-test-id={props.testId} style={cellStyle}>
      {props.children}
      {props.count && <CountPill count={props.count} onClick={props.onCountClick} />}
    </span>
  );
};

export const CellWithCountAndToolTip: React.FC<CellWithCountProps & {
  getPopoverContent?: () => Promise<JSX.Element>;
  wrapWholeCell?: boolean;
}> = props => {
  if (props.wrapWholeCell !== true) {
    return (
      <span data-tb-test-id={props.testId} style={cellStyle}>
        {props.children}
        {props.count &&
          <Tooltip getContent={props.getPopoverContent} position={TooltipPosition.Right}>
            <CountPill count={props.count} />
          </Tooltip>
        }
      </span>
    );
  }

  const cell = (
    <span data-tb-test-id={props.testId} style={cellStyle} tabIndex={-1}>
      {props.children}
      {props.count && <CountPill count={props.count} />}
    </span>
  );

  if (!props.getPopoverContent) {
    return cell;
  }

  return (
    <Tooltip getContent={props.getPopoverContent} position={TooltipPosition.Right} afterDelay={true}>
      {cell}
    </Tooltip>
  );
};
